import React from 'react';

/**
 * LockedIn brand marks — custom SVG geometry, consistent 24×24 grid.
 * Primary brand artwork only; utility controls stay on Lucide/Heroicons elsewhere.
 */

const STROKE = 1.75;

function Icon({ children, viewBox = '0 0 24 24', label, ...props }) {
  return (
    <svg
      viewBox={viewBox}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden={!label}
      aria-label={label}
      role={label ? 'img' : undefined}
      {...props}
    >
      {children}
    </svg>
  );
}

/** LockedIn shield + lock — primary brand mark */
export function LockedInMarkIcon(props) {
  return (
    <Icon {...props} label="LockedIn">
      <path
        d="M12 21.5s7-3.5 7-9.5V6.5l-7-3-7 3v5.5c0 6 7 9.5 7 9.5z"
        stroke="currentColor"
        strokeWidth={STROKE}
        strokeLinejoin="round"
      />
      <rect x="9.5" y="10.5" width="5" height="4.5" rx="0.75" stroke="currentColor" strokeWidth={STROKE} />
      <path d="M11 10.5V9a1 1 0 0 1 2 0v1.5" stroke="currentColor" strokeWidth={STROKE} />
    </Icon>
  );
}

export function LockMarkIcon(props) {
  return (
    <Icon {...props} label="Lock">
      <rect x="6" y="10" width="12" height="9" rx="2" stroke="currentColor" strokeWidth={STROKE} />
      <path d="M8.5 10V7.5a3.5 3.5 0 0 1 7 0V10" stroke="currentColor" strokeWidth={STROKE} />
      <circle cx="12" cy="14.5" r="1.25" fill="currentColor" />
    </Icon>
  );
}

export function ArenaMarkIcon(props) {
  return (
    <Icon {...props} label="Arena">
      <path d="M4 18c0-6 3.5-10 8-10s8 4 8 10" stroke="currentColor" strokeWidth={STROKE} strokeLinecap="round" />
      <path d="M6 18h12" stroke="currentColor" strokeWidth={STROKE} strokeLinecap="round" />
      <circle cx="9" cy="8" r="2" stroke="currentColor" strokeWidth={STROKE} />
      <circle cx="15" cy="7" r="2" stroke="currentColor" strokeWidth={STROKE} />
    </Icon>
  );
}

export function ChallengeMarkIcon(props) {
  return (
    <Icon {...props} label="Challenge">
      <path d="M7 8h2.5a2 2 0 0 0 0-4H7" stroke="currentColor" strokeWidth={STROKE} strokeLinecap="round" />
      <path d="M17 8h-2.5a2 2 0 0 1 0-4H17" stroke="currentColor" strokeWidth={STROKE} strokeLinecap="round" />
      <path d="M6 20h12" stroke="currentColor" strokeWidth={STROKE} />
      <path d="M9 14.5V17c0 .5-.4.9-.8 1.1-1.4.7-2.2 1.8-2.2 3.4" stroke="currentColor" strokeWidth={STROKE} strokeLinecap="round" />
      <path d="M15 14.5V17c0 .5.4.9.8 1.1 1.4.7 2.2 1.8 2.2 3.4" stroke="currentColor" strokeWidth={STROKE} strokeLinecap="round" />
      <path d="M8 4h8v6a4 4 0 0 1-8 0V4z" stroke="currentColor" strokeWidth={STROKE} />
    </Icon>
  );
}

export function WinStreakMarkIcon(props) {
  return (
    <Icon {...props} label="Win streak">
      <path d="M4 18h16" stroke="currentColor" strokeWidth={STROKE} strokeLinecap="round" />
      <path d="M8 14l2 3 4-6 4 6" stroke="currentColor" strokeWidth={STROKE} strokeLinecap="round" strokeLinejoin="round" />
      <path d="M12 4v3" stroke="currentColor" strokeWidth={STROKE} strokeLinecap="round" />
    </Icon>
  );
}

export function BalanceMarkIcon(props) {
  return (
    <Icon {...props} label="Balance">
      <rect x="5" y="9" width="14" height="10" rx="2" stroke="currentColor" strokeWidth={STROKE} />
      <path d="M8 9V6.5a4 4 0 0 1 8 0V9" stroke="currentColor" strokeWidth={STROKE} />
      <path d="M12 12.5v4" stroke="currentColor" strokeWidth={STROKE} strokeLinecap="round" />
      <path d="M10.5 14.5h3" stroke="currentColor" strokeWidth={STROKE} strokeLinecap="round" />
    </Icon>
  );
}
